class AccountStatus {
    constructor() {
        /**
         * Aggregation of `serviceStatus` and `accountingStatus`.
         * Right now webapp only uses this global status.
         * But if we need more detail, `serviceStatus` and `accountStatus` is here to get more detail.
         * Note: only `globalStatus` is used by the webapp for now
         */
        this.globalStatus = null;
        /**
         * Contains the service offers that have overdue payments.
         */
        this.overduePayments = null;
    }
}
const keysOfAccountStatus = ["globalStatus", "overduePayments"];

export { AccountStatus, keysOfAccountStatus };
